'use client'

import React from 'react'
import { cn } from '@/utilities/ui'
import { Container } from './Container'

export const Section: React.FC<{
  children: React.ReactNode
  className?: string
  bgClassName?: string
  px?: boolean
  py?: boolean
  mx?: boolean
}> = ({ children, className, bgClassName, px = true, py = true, mx = true }) => {
  return (
    <Container
      tag="section"
      bgClassName={bgClassName}
      className={cn(py ? 'py-[80px]' : '', className)}
      px={px}
      mx={mx}
    >
      {children}
    </Container>
  )
}
